<template>
  <div>
    <header>
      分类：
      <el-select
        v-model="menuName"
        placeholder="请选择"
      >
        <el-option
          v-for="item in topMenuList"
          :key="item.id"
          :label="item.text"
          :value="item.value"
        >
        </el-option>
      </el-select>
      状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          label="有效"
          value="1"
        > </el-option>
        <el-option
          label="无效"
          value="2"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <!-- default-expand-all -->
    <el-table
      :data="tableListData"
      style="width: 100%; margin-top: 20px"
      row-key="id"
      border
    >
      <el-table-column
        prop="menuName"
        label="菜单名称"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="menuUrl"
        label="菜单地址"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="appCode"
        label="app编号"
      > </el-table-column>
      <el-table-column
        prop="parentName"
        label="菜单类型"
      > </el-table-column>

      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? "有效" : "无效" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="handleClick(scope.row)"
            >新增</el-button
          > -->
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="150px"
        :rules="rules"
      >
        <el-form-item
          label="菜单名称:"
          prop="menuName"
          label-width="160px"
        >
          <el-input v-model="form.menuName"></el-input>
        </el-form-item>
        <el-form-item
          label="APP权限编号:"
          label-width="160px"
        >
          <el-input v-model="form.appCode"></el-input>
        </el-form-item>
        <el-form-item
          label="菜单分类:"
          prop="parentId"
          label-width="160px"
        >
          <el-cascader
            v-model="form.parentId"
            ref="sele"
            :options="tableData"
            :props="props"
            @change="test"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="菜单地址:"
          prop="menuUrl"
          label-width="160px"
        >
          <el-input v-model="form.menuUrl"></el-input>
          <!-- <el-upload
            style="display:inline-block;"
            action=""
            :auto-upload="true"
            :http-request="uploadImg"
            :show-file-list='false'
            :before-upload="beforeAvatarUpload"
          >
            <el-button type="primary">选择</el-button>
          </el-upload>-->
        </el-form-item>
        <el-form-item
          label="菜单图标:"
          label-width="160px"
        >
          <el-input v-model="form.menuImage"></el-input>
          <el-upload
            style="display: inline-block"
            action=""
            :auto-upload="true"
            :http-request="uploadImg"
            :file-list="fileList"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChange"
            list-type="picture"
            :on-remove="handleRemove"
          >
            <el-button
              size="small"
              type="primary"
            >上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="公司级APP图标:"
          prop="appMenuUrl"
          label-width="160px"
        >
          <el-input v-model="form.appMenuUrl"></el-input>
          <el-upload
            style="display: inline-block"
            action=""
            :auto-upload="true"
            :http-request="uploadImg2"
            :file-list="fileList2"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChange2"
            list-type="picture"
            :on-remove="handleRemove2"
          >
            <el-button
              size="small"
              type="primary"
            >上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="项目级APP图标:"
          prop="projectAppMenuUrl"
          label-width="160px"
        >
          <el-input v-model="form.projectAppMenuUrl"></el-input>
          <el-upload
            style="display: inline-block"
            action=""
            :auto-upload="true"
            :http-request="uploadImgProApp"
            :file-list="fileListProApp"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChangeProApp"
            list-type="picture"
            :on-remove="handleRemoveProApp"
          >
            <el-button
              size="small"
              type="primary"
            >上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="显示顺序:"
          prop="sort"
          label-width="160px"
        >
          <el-input v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item
          label="开放功能:"
          prop="checkList"
          label-width="160px"
        >
          <el-checkbox-group v-model="form.checkList">
            <el-checkbox
              v-for="opt in operateList"
              :key="opt.id"
              :label="opt.operateName"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="有效状态:"
          prop="status"
          label-width="160px"
        >
          <el-radio
            v-model="form.status"
            :label="1"
          >有效</el-radio>
          <el-radio
            v-model="form.status"
            :label="2"
          >无效</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <authorization
      :isShow="authorizationShow"
      @isShow="closeAuthor"
    />
  </div>
</template>

<script>
import { provinceAndCityData } from "element-china-area-data";
import authorization from "@/components/authorization.vue";
import { Api_SuperAdmin, Api_System, Api_Base } from "@/api/api";
import { BASE_PLATFORMLOGO_URL } from "@/util/constant";
import { defineAsyncComponent } from "vue";
export default {
  components: {
    authorization,
  },
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      status: -1,
      menuName: 0,
      authorizationShow: false,
      tableData: [],
      tableListData: [],//菜单列表
      addDialogVisible: false,
      form: {
        menuName: "",
        appCode: "",
        parentId: 0,
        menuUrl: "",
        menuImage: "",
        isEnabledAppMenu: false,
        appMenuUrl: "",
        isEnabledProjectAppMenu: false,
        projectAppMenuUrl: "",
        sort: "",
        checkList: [],
        status: 1,
        IsCompanyApp: false,
      },
      rules: {
        menuName: [
          {
            required: true,
            message: "请输入菜单名称",
            trigger: "blur",
          },
        ],
        // appCode: [{
        //   required: true,
        //   message: "请输入App编号",
        //   trigger: "blur",
        // }],
        menuUrl: [
          {
            required: true,
            message: "请输入菜单路径",
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择菜单分类",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请输入菜单状态",
            trigger: "blur",
          },
        ],
        checkList: [
          {
            required: true,
            message: "请选择开放功能",
            trigger: "blur",
          },
        ],
        IsCompanyApp: [
          {
            required: true,
            message: "请选择是否启用公司级APP",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入显示顺序",
            trigger: "blur",
          },
        ],
        // appMenuUrl: [
        //   {
        //     required: true,
        //     message: "请上传公司及APP图标",
        //     trigger: "blur",
        //   },
        // ],
        // projectAppMenuUrl: [
        //   {
        //     required: true,
        //     message: "请上传项目级APP图标",
        //     trigger: "blur",
        //   },
        // ],
      },
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      operateList: [],
      props: {
        value: "id",
        label: "menuName",
        children: "listTreeMenus",
        checkStrictly: true,
        emitPath: false,
      },
      topMenuList: [
        {
          text: "全部",
          value: 0,
        },
      ],
      fileList: [],
      fileList2: [],
      fileListProApp: [],
      editId: 0,
    };
  },
  created() {
    this.getTreeType();
    this.getList();
    this.getOperateList();
    this.getTopMenus();
  },
  methods: {
    uploadImg(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then((res) => {
        if (res.data.data[0].fileUrl) {
          this.form.menuImage = res.data.data[0].fileUrl;
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }
      });
    },
    // APP图标
    uploadImg2(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then((res) => {
        if (res.data.data[0].fileUrl) {
          this.form = { ...this.form, appMenuUrl: res.data.data[0].fileUrl }
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }
      });
    },
    // 项目APP图标
    uploadImgProApp(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then((res) => {
        if (res.data.data[0].fileUrl) {
          this.form = { ...this.form, projectAppMenuUrl: res.data.data[0].fileUrl }
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      const typeArr = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
      const isJPG = typeArr.indexOf(file.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("只能上传图片!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    handleChange2(file, fileList) {
      this.fileList2 = [];
      this.fileList2.push(file);
    },
    handleChangeProApp(file, fileList) {
      this.fileListProApp = [];
      this.fileListProApp.push(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.form.menuImage = "";
    },
    handleRemove2(file, fileList) {
      this.fileList2 = [];
      this.form.appMenuUrl = "";
    },
    handleRemoveProApp(file, fileList) {
      this.fileListProApp = [];
      this.form.projectAppMenuUrl = "";
    },
    // 条件查询中的列表
    getTopMenus() {
      // this.topMenuList = [
      //   {
      //     text: '全部',
      //     value: ''
      //   }
      // ]
      Api_SuperAdmin.getTopMenus().then((res) => {
        const result = res.data;
        if (result.statusCode == 200) {
          result.data.map((item) => {
            this.topMenuList.push({
              text: item.menuName,
              value: item.id,
            });
          });
        }
      });
    },
    handleClose() {
      this.resetForm("ruleForm");
    },
    openAdd() {
      this.addDialogVisible = true;
      this.fileList = [];
      this.fileList2 = [];
      this.fileListProApp = []
      console.log(this.fileListProApp);
      this.clear();
      // this.getOperateList()
    },
    clear() {
      this.form = {
        menuName: "",
        appCode: "",
        parentId: "",
        menuUrl: "",
        menuImage: "",
        sort: "",
        checkList: [],
        status: 1,
      };

    },
    edit(item) {
      this.fileList = [];
      this.fileList2 = [];
      this.fileListProApp = [];
      this.addDialogVisible = true;
      this.editId = item.id;
      Api_SuperAdmin.menuDetail(item.id).then((res) => {
        const result = res.data;
        const f = Object.getOwnPropertyNames(this.form);
        for (let key in result.data) {
          // 只传对象中存在的属性，否则编辑的其他值会被这个值覆盖
          if (f.includes(key)) {
            this.form[key] = result.data[key];
          }
        }
        this.form["id"] = item.id;
        if (result.data.menuImage) {
          this.fileList.push({ url: BASE_PLATFORMLOGO_URL + result.data.menuImage });
        }
        if (result.data.appMenuUrl) {
          this.fileList2.push({ url: BASE_PLATFORMLOGO_URL + result.data.appMenuUrl });
        }
        if (result.data.projectAppMenuUrl) {
          this.fileListProApp.push({ url: BASE_PLATFORMLOGO_URL + result.data.projectAppMenuUrl })
        }
        // this.getOperateList()
      });
    },
    // 开放功能列表
    getOperateList() {
      this.form.checkList = [];
      Api_System.getOperateList().then((res) => {
        const result = res.data;
        if (result.statusCode == 200) {
          this.operateList = result.data;
          this.operateList.map((item) => {
            this.form.checkList.push(item.operateName);
          });
        }
      });
    },
    test(val) {
      this.form.menuLevel = this.$refs["sele"].getCheckedNodes()[0].level + 1;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addDialogVisible = false;
      // this.form = {}
      this.$refs[formName].resetFields();
      this.editId = 0;
    },
    del(item) {
      this.$confirm("是否删除此菜单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.delMenu(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      let item = this.form;
      if (this.form.id) {
        Api_SuperAdmin.editMenu(item).then((res) => {
          if (res.data.data && res.data.succeeded) {
            this.$message({
              type: "success",
              message: "更新成功!",
            });
            this.addDialogVisible = false;
            // this.form = {}
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      } else {
        Api_SuperAdmin.addMenu(item).then((res) => {
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "更新成功!",
            });
            this.addDialogVisible = false;
            // this.form = {}
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      }
    },
    getTreeType() {
      //    功能类型列表
      const params = {
        menuName: this.menuName,
        parentId: 0,
        status: this.status,
      };
      Api_SuperAdmin.getTopMenus().then((res) => {
        console.log(res);
        this.tableData = res.data.data;
      });
    },
    getList() {
      console.log(this.menuName);
      //    功能类型列表
      const params = {
        // menuName: this.menuName,
        parentId: this.menuName,
        status: this.status,
        pageSize: this.pagesize,
        pageIndex: this.currentPage
      };
      Api_SuperAdmin.menuPageList(params).then((res) => {
        this.tableListData = res.data.data.tList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    closeAuthor(val) {
      this.authorizationShow = val;
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleClick(val) {
      this.form.parentId = val.id;
      this.addDialogVisible = true;
    },
  },
};
</script>